export default __webpack_public_path__ + "static/media/253.cb4b2096.png";